module.exports = __webpack_public_path__ + "img/btn_add@2x.19ed4569.png";